import { render } from "./DocAccount.vue?vue&type=template&id=10e0150a&scoped=true"
import script from "./DocAccount.vue?vue&type=script&lang=js"
export * from "./DocAccount.vue?vue&type=script&lang=js"

import "./DocAccount.vue?vue&type=style&index=0&id=10e0150a&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e0150a"]])

export default __exports__